
const CustomerRoutes = [
  {
    path: '/ecommerce/loyalty',
    name: 'loyalty',
    component: () => import(/* webpackChunkName: "loyalty" */ './Loyalty'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'levels',
        name: 'levels',
        component: () => import(/* webpackChunkName: "loyalty-levels" */ './components/Levels'),
        meta: {
          breadCrumbs: [
            {
              name: 'Loyalty Levels',
              path: '/ecommerce/loyalty/levels',
            },
          ],
        },
      },
      {
        path: 'levels/:id/items',
        name: 'level-items',
        component: () => import(/* webpackChunkName: "loyalty-items" */ './components/LevelItems'),
        meta: {
          breadCrumbs: [
            {
              name: 'Loyalty Levels',
              path: '/ecommerce/loyalty/levels',
            },
            {
              name: 'Loyalty Levels Items',
              path: '',
            },
          ],
        },
      },
      {
        path: 'levels/items',
        name: 'all-level-items',
        component: () => import(/* webpackChunkName: "loyalty-items" */ './components/LevelItems'),
        meta: {
          breadCrumbs: [
            {
              name: 'Loyalty Levels',
              path: '/ecommerce/loyalty/levels',
            },
            {
              name: 'Loyalty Levels Items',
              path: '',
            },
          ],
        },
      },
      {
        path: 'levels/:id/customers',
        name: 'level-customers',
        component: () => import(/* webpackChunkName: "loyalty-customers" */ './components/LevelCustomers'),
        meta: {
          breadCrumbs: [
            {
              name: 'Loyalty Levels',
              path: '/ecommerce/loyalty/levels',
            },
            {
              name: 'Loyalty Levels Customers',
              path: '',
            },
          ],
        },
      },
      {
        path: 'levels/customers',
        name: 'all-level-customers',
        component: () => import(/* webpackChunkName: "loyalty-customers" */ './components/LevelCustomers'),
        meta: {
          breadCrumbs: [
            {
              name: 'Loyalty Levels',
              path: '/ecommerce/loyalty/levels',
            },
            {
              name: 'Loyalty Levels Customers',
              path: '',
            },
          ],
        },
      },
    ],
  },
];

export default CustomerRoutes;
